<div [formGroup]="parentForm" [attr.class]="getAmountFieldContainerClass()">
  <label id={{labelId}} [ngClass]="amountFieldIsInvalid ? 'error-text' : 'label'" for="amount">{{amountFieldLabel}}</label>
  <mm-ach-max-transfer-amount [transactionType]="this.transactionType" [maxTransferAmount]="this.maxTransferAmount" *ngIf="this.maxTransferAmount">
  </mm-ach-max-transfer-amount>
  <div class="input-container amountInput">
    <input class="sdps-input sdps-input--small" [class.is-invalid]="amountFieldIsInvalid" id="amount" name="amount"
      type="text" formControlName="amount" (blur)="formatAmount()" data-testid="amount-input"
      (paste)="onPaste($event)" (keydown)="validationService.validateNumberInput($event, amountAllowedChars)">
    <i *ngIf="parentForm.controls.amount?.value && !parentForm.controls.amount?.disabled" (click)="clearAmount()"
      class="sch-thin-x" data-testid="little-x"></i>
  </div>
  <div *ngIf="parentForm.controls.amount?.invalid && parentForm.controls.amount?.touched" class="alert-box">
    <div *ngIf="amount?.invalid" class="alert-text">
      {{amountError}}
    </div>
  </div>
  <div class="alert-text" *ngIf="hasInsufficientFundError">
    {{insufficientFundErrorPtrs}}
  </div>
</div>